
import { Component, Prop, Watch,Emit,FormComponentBase} from "@/lib";
@Component({name:"hi-span"})
export default class HiSpan extends FormComponentBase {
  @Prop({ type: [String, Number] }) value: any;
}
